import React from 'react';

import { zero } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import type { ExamReviewRouteParams, ReviewRouteParams } from '/imports/ui/pages/review/routes';
import { examReviewRoute, reviewRoute } from '/imports/ui/pages/review/routes';

const ReviewLazy = React.lazy(() => import('./Review'));
const ReviewExamLazy = React.lazy(() => import('./ReviewExam'));

const Review = ({ fileKey, snapshotId, section, ...rest }: ReviewRouteParams) => (
  <Authorise deny={['exam', 'lti']}>
    <ReviewLazy
      fileKey={fileKey ?? undefined}
      snapshotId={snapshotId ?? undefined}
      section={section ?? undefined}
      {...rest}
    />
  </Authorise>
);

const ReviewExam = ({ fileKey, snapshotId, section, ...rest }: ExamReviewRouteParams) => (
  <Authorise deny={['exam', 'lti']}>
    <ReviewExamLazy
      fileKey={fileKey ?? undefined}
      snapshotId={snapshotId ?? undefined}
      section={section ?? undefined}
      {...rest}
    />
  </Authorise>
);

export const reviewRouter = zero()
  .alt(reviewRoute.parser.map((props) => <Review {...props} />))
  .alt(examReviewRoute.parser.map((props) => <ReviewExam {...props} />));
